import { selectorFamily } from 'recoil';
import { difference } from '../utils/array';
import {
  completedComponentIdsState,
  compositedScenarioItemState, recentlyItemCompleted,
  scenarioState,
} from './scenarioState';
import { formState, inputErrorsState } from './formState';

export const completedComponentState = selectorFamily<boolean, string>({
  key: 'completedComponent',
  get: (componentId) => ({get}) => {
    return get(completedComponentIdsState).includes(componentId);
  },
  set: (componentId) => ({set, get}, completed) => {
    const item = get(compositedScenarioItemState(componentId));
    const items = get(scenarioState).items;
    const index = items.indexOf(item);
    if (index < 0) return; // scenarioの切り替えタイミング
    const completedIds = get(completedComponentIdsState);
    const restComponentIds = items
      .filter((_, i) => i > index)
      .flatMap(i => i.components.map(c => c.id));

    if (completed === true) {
      set(completedComponentIdsState, prev => difference(prev.includes(componentId) ? prev : [...prev, componentId], restComponentIds))
      const ids = [...completedIds, componentId];
      if (item.components.length === 1 && item.components.every(c => ids.includes(c.id))) {
        set(recentlyItemCompleted, true);
      }
    } else {
      set(completedComponentIdsState, prev => difference(prev.filter(id => id !== componentId), restComponentIds));
    }

    function deleteRestComponentValue<T>() {
      return (prev: {[key: string]: T}) => {
        const ret = {...prev};
        for (const id of restComponentIds) {
          delete ret[id];
        }
        return ret;
      };
    }

    set(formState, deleteRestComponentValue());
    set(inputErrorsState, deleteRestComponentValue())
  },
});
